<div class="widget" [ngClass]="{'loader-shown': loading}">
  <div class="widget-loader widget-loader-admin-review">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
    </div>
    <div class="widget-loader-content">
      <div class="loader-element image-loading"></div>
      <div class="loader-element text-loading"></div>
      <div class="loader-element small-loading"></div>
    </div>
  </div>
  <div class="widget-header">
    <span class="custom-icon">
      <span class="icon material-icons-round">task</span>
    </span>
    <span class="title">{{ stageName }}</span>
  </div>
  <div class="widget-content">
    <div *ngIf="!stageId">Not connected to a stage</div>

    <div *ngIf="stageId && (timeLeftToStart > 0 || !isDeadlinePassed)" class="custom-message">
      <span class="icon material-icons reviewed">search</span>
      <p>All submitted applications are being reviewed for eligibility.</p>
      <small></small>
    </div>

    <div *ngIf="stageId && isEliminated && timeLeftToStart <= 0 && isDeadlinePassed" class="custom-message">
      <span class="icon material-icons passed-deadline">cancel</span>
      <p>System Message</p>
      <small>We regret to inform you that you have been eliminated from the competition at this stage.</small>
    </div>

    <div *ngIf="stageId && !isEliminated && isValid === false && timeLeftToStart <= 0 && isDeadlinePassed" class="custom-message">
      <span class="icon material-icons passed-deadline">cancel</span>
      <p>Your application is invalid.</p>
      <small>Check your email for more details.</small>
    </div>

    <div *ngIf="stageId && !isEliminated && isValid === true && timeLeftToStart <= 0 && isDeadlinePassed" class="custom-message">
      <span class="icon material-icons submitted">check_circle</span>
      <p>Congratulations! Your application is moving onto the next phase of the competition.</p>
      <small>Check your email for more details.</small>
    </div>
    
  </div>
</div>